import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Checkbox from '../Checkbox';

import i18n from '../../utils/i18n';

import styles from './styles.scss';

export default function OrderRatingIssues({ selectedIssues, onChange, options }) {
  return (
    <div>
      <Heading level={3} size="x-small" spacing="x-large 0 medium">
        {i18n.gettext('order_rating.options_question')}
      </Heading>
      <div className={styles.options}>
        {options.map((option) => (
          <div className={styles.option} key={option.value}>
            <Checkbox
              id={option.value}
              labelContent={() => (
                <Fragment>
                  <span className={styles.icon}>
                    <Icon component={option.icon} size={24} color="grey" spacing="0 medium 0 0" />
                  </span>
                  <span>{option.label}</span>
                </Fragment>
              )}
              isChecked={selectedIssues.includes(option.value)}
              onChange={onChange}
              isLabelLeftOnMobile
            />
          </div>
        ))}
      </div>
    </div>
  );
}

OrderRatingIssues.propTypes = {
  selectedIssues: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** A list of feedback for improvement options */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired, // eslint-disable-line react/no-typos
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};
